import { client } from '@/shared/http/client';

import type {
  HomeScreenGranted,
  HomeScreenOffer,
  OptInGranted,
  OptInOffer,
  PromptAction,
  PromptChannel,
} from './types';

/** PRAT-165 — push da loja. Tudo escopado pelo slug; o token vai quando há login. */
const base = (slug: string) => `api/app/merchants/${encodeURIComponent(slug)}`;

export async function getHomeScreenOffer(slug: string): Promise<HomeScreenOffer[]> {
  const res = await client
    .get(`${base(slug)}/push/home-screen`)
    .json<{ data: { rewards: HomeScreenOffer[] } }>();
  return res.data?.rewards ?? [];
}

/** PRAT-201 — incentivo por ativar os avisos nesta loja (null = sem incentivo). */
export async function getOptInOffer(slug: string): Promise<OptInOffer | null> {
  const res = await client
    .get(`${base(slug)}/push/home-screen`)
    .json<{ data: { optin?: OptInOffer | null } }>();
  return res.data?.optin ?? null;
}

/** Inscreve o aparelho; devolve o incentivo quando o cliente acabou de ganhar (PRAT-201). */
export async function registerPushSubscription(
  slug: string,
  body: { subscription_id: string; platform?: string; standalone?: boolean; active?: boolean }
): Promise<OptInGranted | null> {
  const res = await client
    .post(`${base(slug)}/push/subscriptions`, { json: body })
    .json<{ data?: { reward?: OptInGranted | null } }>();
  return res?.data?.reward ?? null;
}

/** PRAT-201 — o que o aparelho fez com o convite. Nunca atrapalha a tela. */
export function recordPromptEvent(
  slug: string,
  body: {
    channel: PromptChannel;
    action: PromptAction;
    device: string;
    platform?: string;
    standalone?: boolean;
    /** PRAT-90: por que o Ativar falhou (só em `error`). */
    reason?: string;
  }
): void {
  client.post(`${base(slug)}/push/prompt-events`, { json: body }).catch(() => undefined);
}

export async function claimHomeScreenReward(slug: string): Promise<HomeScreenGranted[]> {
  const res = await client
    .post(`api/app/merchants/${encodeURIComponent(slug)}/push/home-screen`, {
      json: { standalone: true },
    })
    .json<{ data: { rewards: HomeScreenGranted[] } }>();
  return res.data?.rewards ?? [];
}
